"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
require("core-js/modules/es6.string.link.js");
var _defaultsDeep2 = _interopRequireDefault(require("lodash/defaultsDeep"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _react = _interopRequireWildcard(require("react"));
var _clickWrapper = _interopRequireDefault(require("./click-wrapper"));
var _excluded = ["children", "onClick", "additionalAttributes", "className", "component", "ext_click_id", "finishType", "hasPrequalified", "impressionId", "isCC", "link", "linkType", "monetizable", "newWindow", "pageNumber", "prequalId", "productDisplayDriver", "productId", "productImpressionId", "productPosition", "referringUrl", "rel", "sectionName", "sectionPosition", "shortButton"];
/* eslint-disable camelcase */
var getClickProps = function getClickProps(props) {
  var additionalAttributes = props.additionalAttributes,
    ext_click_id = props.ext_click_id,
    finishType = props.finishType,
    hasPrequalified = props.hasPrequalified,
    impressionId = props.impressionId,
    link = props.link,
    linkType = props.linkType,
    monetizable = props.monetizable,
    pageNumber = props.pageNumber,
    productDisplayDriver = props.productDisplayDriver,
    productImpressionId = props.productImpressionId,
    productPosition = props.productPosition,
    referringUrl = props.referringUrl,
    sectionName = props.sectionName,
    sectionPosition = props.sectionPosition,
    shortButton = props.shortButton,
    prequalId = props.prequalId;
  var clickProps = (0, _pick2.default)(props, ['eventProps', 'pageViewId', 'className', 'component', 'disabled', 'id', 'rel', 'primary', 'secondary', 'tertiary', 'newWindow', ext_click_id ? 'ext_click_id' : '']);
  clickProps.short = shortButton;
  clickProps.href = link;
  if (referringUrl) {
    clickProps.href = "".concat(link, "&url=").concat(referringUrl);
    clickProps.rel = 'sponsored noreferrer noopener';
  }
  var clickHeaderProps = (0, _pick2.default)(props, ['pageNumber', 'productPosition', 'productLocation', 'productInstance', 'sectionPosition', 'productId', 'productSlug', 'linkType']);
  clickProps.eventProps = (0, _defaultsDeep2.default)(clickProps.eventProps || {}, {
    clickHeader: clickHeaderProps,
    finish_type: finishType,
    has_prequalified: hasPrequalified,
    impression_id: impressionId,
    link_type: linkType,
    monetizable: monetizable,
    page_number: pageNumber,
    product_impression_id: productImpressionId,
    product_display_driver: productDisplayDriver,
    product_position: productPosition,
    section_name: sectionName,
    section_position: sectionPosition
  });
  if (prequalId) {
    clickProps.eventProps.prequal_id = prequalId;
  }
  if (ext_click_id) {
    clickProps.eventProps.ext_click_id = ext_click_id;
  }
  if (additionalAttributes) {
    clickProps.eventProps.additional_attributes = JSON.stringify(additionalAttributes);
  }
  return clickProps;
};
var ApplyNowLink = function ApplyNowLink(_ref) {
  var children = _ref.children,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    additionalAttributes = _ref.additionalAttributes,
    className = _ref.className,
    _ref$component = _ref.component,
    component = _ref$component === void 0 ? 'a' : _ref$component,
    ext_click_id = _ref.ext_click_id,
    _ref$finishType = _ref.finishType,
    finishType = _ref$finishType === void 0 ? 'external_application' : _ref$finishType,
    _ref$hasPrequalified = _ref.hasPrequalified,
    hasPrequalified = _ref$hasPrequalified === void 0 ? false : _ref$hasPrequalified,
    impressionId = _ref.impressionId,
    _ref$isCC = _ref.isCC,
    isCC = _ref$isCC === void 0 ? false : _ref$isCC,
    link = _ref.link,
    linkType = _ref.linkType,
    monetizable = _ref.monetizable,
    _ref$newWindow = _ref.newWindow,
    newWindow = _ref$newWindow === void 0 ? true : _ref$newWindow,
    pageNumber = _ref.pageNumber,
    prequalId = _ref.prequalId,
    productDisplayDriver = _ref.productDisplayDriver,
    productId = _ref.productId,
    productImpressionId = _ref.productImpressionId,
    productPosition = _ref.productPosition,
    referringUrl = _ref.referringUrl,
    _ref$rel = _ref.rel,
    rel = _ref$rel === void 0 ? 'sponsored' : _ref$rel,
    sectionName = _ref.sectionName,
    sectionPosition = _ref.sectionPosition,
    _ref$shortButton = _ref.shortButton,
    shortButton = _ref$shortButton === void 0 ? false : _ref$shortButton,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var appendSourceUrl = (0, _react.useCallback)(function (e) {
    if (!e) return;
    if (typeof window === 'undefined') return;
    var href = e.currentTarget.getAttribute('href');
    if (!href) return;
    if (/source_url/g.test(href)) return;
    var sourceUrl = window.location.href;
    var queryPrefix = href.indexOf('?') > -1 ? '&' : '?';
    var newHref = "".concat(href).concat(queryPrefix, "source_url=").concat(encodeURIComponent(sourceUrl));
    e.currentTarget.setAttribute('href', newHref);
  }, []);
  var handleClick = (0, _react.useCallback)(function (e) {
    appendSourceUrl(e);
    onClick(e);
  }, [onClick, appendSourceUrl]);
  var handleMouseDown = (0, _react.useCallback)(function (e) {
    appendSourceUrl(e);
  }, [appendSourceUrl]);
  return /*#__PURE__*/_react.default.createElement(_clickWrapper.default, (0, _extends2.default)({
    onClick: handleClick,
    onMouseDown: handleMouseDown
  }, getClickProps((0, _objectSpread2.default)({
    additionalAttributes: additionalAttributes,
    className: className,
    component: component,
    ext_click_id: ext_click_id,
    finishType: finishType,
    hasPrequalified: hasPrequalified,
    impressionId: impressionId,
    isCC: isCC,
    link: link,
    linkType: linkType,
    monetizable: monetizable,
    newWindow: newWindow,
    pageNumber: pageNumber,
    prequalId: prequalId,
    productDisplayDriver: productDisplayDriver,
    productId: productId,
    productImpressionId: productImpressionId,
    productPosition: productPosition,
    referringUrl: referringUrl,
    rel: rel,
    sectionName: sectionName,
    sectionPosition: sectionPosition,
    shortButton: shortButton
  }, props))), children);
};
var _default = ApplyNowLink;
exports.default = _default;